import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'QueryRoot', currentUser?: { __typename?: 'User', id: string, name: string } | null };

export type CurrentAdministratorQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentAdministratorQuery = { __typename?: 'QueryRoot', currentAdministrator?: { __typename?: 'Administrator', id: string, name: string } | null };


export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    id
    name
  }
}
    `;

export function useCurrentUserQuery(options?: Omit<Urql.UseQueryArgs<CurrentUserQueryVariables>, 'query'>) {
  return Urql.useQuery<CurrentUserQuery, CurrentUserQueryVariables>({ query: CurrentUserDocument, ...options });
};
export const CurrentAdministratorDocument = gql`
    query currentAdministrator {
  currentAdministrator {
    id
    name
  }
}
    `;

export function useCurrentAdministratorQuery(options?: Omit<Urql.UseQueryArgs<CurrentAdministratorQueryVariables>, 'query'>) {
  return Urql.useQuery<CurrentAdministratorQuery, CurrentAdministratorQueryVariables>({ query: CurrentAdministratorDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCurrentUserQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ currentUser })
 *   )
 * })
 */
export const mockCurrentUserQuery = (resolver: ResponseResolver<GraphQLRequest<CurrentUserQueryVariables>, GraphQLContext<CurrentUserQuery>, any>) =>
  graphql.query<CurrentUserQuery, CurrentUserQueryVariables>(
    'currentUser',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCurrentAdministratorQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ currentAdministrator })
 *   )
 * })
 */
export const mockCurrentAdministratorQuery = (resolver: ResponseResolver<GraphQLRequest<CurrentAdministratorQueryVariables>, GraphQLContext<CurrentAdministratorQuery>, any>) =>
  graphql.query<CurrentAdministratorQuery, CurrentAdministratorQueryVariables>(
    'currentAdministrator',
    resolver
  )
